import { z } from 'zod';
/** Immutable audit event (BR-008, FR-810, §13). */
export const AuditEvent = z.object({
    id: z.string(),
    action: z.string(), // e.g. ticket.transitioned, ticket.comment.added
    actorType: z.enum(['user', 'api_key', 'agent', 'system', 'integration']),
    actorId: z.string().nullable(),
    actorName: z.string().nullable(),
    targetType: z.string(), // ticket | message | release ...
    targetId: z.string(),
    before: z.unknown().nullable(),
    after: z.unknown().nullable(),
    correlationId: z.string().nullable(),
    externalEventId: z.string().nullable(),
    createdAt: z.string(),
});
// NOTE: the legacy flat `DocPage` / `CreateDocPageInput` contracts were retired
// when the Docs & Knowledge Base portal replaced them. The new hierarchical
// Space → Folder → Document → Page model lives in `docs.ts`.
//# sourceMappingURL=audit.js.map